//#region import
import React, { useEffect, useState } from 'react'
import { Avatar, Divider, Grid, IconButton, Popover, Tooltip, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { FnAxios, FnDialog, I18n } from 'utilities/utilities';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { BtnAddOnTable, BtnEditOnTable, BtnViewOnTable } from 'components/Button/ButtonTable';
import { GetMenuPermission } from 'utilities/SystemFunction';
import InfoIcon from '@mui/icons-material/Info';
import PDFIcon from "../../../../src/assets/images/DocTypeIcon/PDF.svg";
import { Circle } from '@mui/icons-material';
import DialogPreview from 'components/DialogPreview/DialogPreview';
import { FormProvider, useForm } from 'react-hook-form';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import { BtnClear, BtnSearch } from 'components/Button/ButtonAll';
import { TextBoxItem } from 'components/Input/TextBox';
import { MultipleSelectItem } from 'components/Input/Select/MultipleSelectItem';
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import moment from 'moment';
//#endregion

const EquipmentListTabel = ({ sMode }) => {
    const navigate = useNavigate();

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const [loadingTable, setLoadingTable] = useState(false);
    const [sUpdateName, setUpdateName] = useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [arrMaterialType, setMaterialType] = useState<any>([]);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
    });
    const [isOpenFile, setIsOpenFile] = useState(false);
    const [arrModalFile, setArrModalFile] = useState([]);
    const [isPermission, setPermission] = useState<boolean>(false); // Permission
    const [arrGovernmentUnit, setarrGovernmentUnit] = useState([]);
    const [arrMethodType, setarrMethodType] = useState([]);


    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const currentDate = new Date(); // Get the current date
    const form = useForm({
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sDocumentNo: null,
            nReceiverUnitType: null,
            dStartDate: null,
            dEndDate: null,
        } as any,
    });

    const getTableEquipment = (p: PaginationInterface) => {
        setLoadingTable(true);
        let ObjForm = form.getValues();
        let nStart = ObjForm.dStartDate ? ObjForm.dStartDate.valueOf() : null;
        let nEnd = ObjForm.dEndDate ? ObjForm.dEndDate.valueOf() : null;

        let Param = {
            ...p,
            nStart: nStart,
            nEnd: nEnd,
            lstMethodType: ObjForm.nMethodType ? ObjForm.nMethodType : [],
            lstGovernmentUnit: ObjForm.nGovernmentUnit ? ObjForm.nGovernmentUnit : [],
            sOrderNo: ObjForm.sOrderNo,
            nYear: ObjForm.dYear ? ObjForm.dYear.valueOf() : null
        };
        if (sMode == "Receive") {
            AxiosFn.Post(`Equipment/GetTableReceiveEquipment`, Param, (result) => {
                setLoadingTable(false);
                setDataRow({
                    ...p,
                    arrRows: [...result.lstDataReceiveMaterial],
                    nDataLength: result.ObjTable?.nDataLength,
                    nPageIndex: result.ObjTable?.nPageIndex,
                });
            });
        } else if (sMode == "Withdraw") {
            AxiosFn.Post(`Equipment/GetTablWithdrawEquipment`, Param, (result) => {
                setLoadingTable(false);
                setMaterialType(result.lstReceiverUnitType);
                setDataRow({
                    ...p,
                    arrRows: [...result.lstDataWithdraw],
                    nDataLength: result.ObjTable?.nDataLength,
                    nPageIndex: result.ObjTable?.nPageIndex,
                });
            });
        }
        else if (sMode == "Return") {
            AxiosFn.Post(`Equipment/GetTabReturnEquipmentl`, Param, (result) => {
                setLoadingTable(false);
                setMaterialType(result.lstReceiverUnitType);
                setDataRow({
                    ...p,
                    arrRows: [...result.lstDataReturn],
                    nDataLength: result.ObjTable?.nDataLength,
                    nPageIndex: result.ObjTable?.nPageIndex,

                });
            });
        } else if (sMode == "Cutoff") {
            AxiosFn.Post(`Equipment/GetTabCusOffEquipmentl`, Param, (result) => {
                setLoadingTable(false);
                setDataRow({
                    ...p,
                    arrRows: [...result.lstTableCusOffEquipment],
                    nDataLength: result.ObjTable?.nDataLength,
                    nPageIndex: result.ObjTable?.nPageIndex,

                });
            });
        }
    };

    const onClear = () => {
        form.reset();
        getTableEquipment(dataRow);
    }

    /*Pop UpdateName*/
    const handleViewInfo = (e) => {
        setUpdateName(e.sUpdateName);
    }
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    /*Receive File */
    const open = Boolean(anchorEl);

    const handleOpenFile = (e) => {
        let sUrl = e;
        window.open(sUrl, "_blank", "noreferrer");
    };

    /*Table Receive */
    const dataColumn: any = [
        {
            renderHeader: (item) => (
                <>
                    <BtnAddOnTable
                        IsDisabled={!isPermission}
                        onClick={() => navigate("/EquipmentReceiveForm?sMode=" + sMode)}
                        id={"Add"} />
                </>
            ),
            field: "ปุ่ม (เพิ่ม/แก้ไข)",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 60,
            getActions: (item) => {
                if (!isPermission) {
                    return [
                        <BtnViewOnTable
                            id="btnView"
                            key={item.row.sID}
                            onClick={() => goToEditReceive(item.row.sID)}
                        />
                    ];
                } else {
                    return [
                        <BtnEditOnTable
                            key={item.row.sID}
                            id="btnEdit"
                            onClick={() => goToEditReceive(item.row.sID)}
                        />
                    ];
                }
            },
        },
        {
            field: "sReceive",
            headerName: "วันที่ได้มา",
            headerAlign: "center",
            align: "Left",
            sortable: true,
            width: 100,
        },
        {
            field: "sOrderNo",
            headerName: "เลขที่เอกสาร",
            headerAlign: "center",
            align: "Left",
            sortable: true,
            width: 150,
        },
        {
            field: "sGovernmentUnit",
            headerName: "หน่วยงาน",
            headerAlign: "center",
            align: "Left",
            sortable: true,
            width: 250,
            flex: 2,
        },
        {
            field: "sMethodTypeID",
            headerName: "วิธีได้มา",
            headerAlign: "center",
            align: "Left",
            sortable: true,
            width: 100,
        },
        {
            field: "sEquipmentTotal",
            headerName: "จำนวนครุภัณฑ์",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 100,
        },

        {
            field: "sUpdate",
            headerName: "วันที่แก้ไขล่าสุด",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 170,
            renderCell: (item) => {
                return (
                    <>
                        <Grid sx={{ mr: "4px" }}>
                            {item.row.sUpdate}
                        </Grid>
                        <IconButton size="small"
                            onClick={(e) => { handleClick(e); handleViewInfo(item.row); }}
                        >
                            <InfoIcon
                                style={{ color: "#6e130d", cursor: "pointer" }}
                            />
                        </IconButton>
                    </>
                )
            }
        },
    ];

    const goToEditReceive = (sID: string) => {
        navigate(`/EquipmentReceiveForm?sMode=${sMode}&sID=${encodeURI(sID)}`);
    };

    const onDeleteReceive = (e) => {
        DialogFn.Submit("คุณต้องการลบข้อมูลใช่หรือไม่ ?", () => {
            AxiosFn.Post(`Equipment/RemoveDataTable`, { lstID: e }, (result) => {
                if (result.nStatusCode === 200) {
                    DialogFn.Success("ลบสำเร็จ", () => {
                        getTableEquipment(dataRow);
                    });
                }
            });
        });
    }

    /*Table Withdraw */
    const dataColumnWithdraw: any = [
        {
            renderHeader: (item) => (
                <>
                    <BtnAddOnTable
                        IsDisabled={!isPermission}
                        onClick={() => navigate("/EquipmentWithdrawForm?sMode=" + sMode)}
                        id={"Add"} />
                </>
            ),
            field: "ปุ่ม (เพิ่ม/แก้ไข)",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 60,
            getActions: (item) => {
                if (!isPermission) {
                    return [
                        <BtnViewOnTable
                            id="btnView"
                            key={item.row.sID}
                            onClick={() => goToEdit(item.row.sID)}
                        />
                    ];
                } else {
                    return [
                        <BtnEditOnTable
                            key={item.row.sID}
                            id="btnEdit"
                            onClick={() => goToEdit(item.row.sID)}
                        />
                    ];
                }
            },
        },
        {
            field: "sWithdraw",
            headerName: `${I18n.SetText("Equipment.sWithdrawDate")}`,
            headerAlign: "center",
            align: "Left",
            sortable: true,
            width: 120,
        },
        {
            field: "sDocumentNo",
            headerName: `${I18n.SetText("Equipment.sWithdrawOrder")}`,
            headerAlign: "center",
            align: "Left",
            sortable: true,
            width: 150,
        },
        {
            field: "sNameWithdraw",
            headerName: `${I18n.SetText("Equipment.sNameWithdraw")}`,
            headerAlign: "center",
            align: "Left",
            sortable: true,
            width: 250,
            flex: 1,
        },
        {
            field: "sReceiverUnitType",
            headerName: `${I18n.SetText("Equipment.sGovernmentUnitWithdraw")}`,
            headerAlign: "center",
            align: "Left",
            sortable: true,
            width: 190,
        },
        {
            field: "sEquipmentTotal",
            headerName: `${I18n.SetText("Equipment.sWithdrawTotal")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 120,
        },
        {
            field: "sUpdate",
            headerName: "วันที่แก้ไขล่าสุด",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 170,
            renderCell: (item) => {
                return (
                    <>
                        <Grid sx={{ mr: "4px" }}>
                            {item.row.sUpdate}
                        </Grid>
                        <IconButton size="small"
                            onClick={(e) => { handleClick(e); handleViewInfo(item.row); }}
                        >
                            <InfoIcon
                                style={{ color: "#6e130d", cursor: "pointer" }}
                            />
                        </IconButton>
                    </>
                )
            }
        },
    ];

    /*Edit Withdraw */
    const goToEdit = (sID: string) => {
        navigate(`/EquipmentWithdrawForm?sMode=${sMode}&sID=${encodeURI(sID)}`);
    };

    /*DeleteTable Withdraw */
    const onDeleteWithdraw = (e) => {
        DialogFn.Submit("คุณต้องการลบข้อมูลใช่หรือไม่ ?", () => {
            AxiosFn.Post(`Equipment/RemoveDataTableWithdraw`, { lstID: e }, (result) => {
                if (result.nStatusCode === 200) {
                    DialogFn.Success("ลบสำเร็จ", () => {
                        getTableEquipment(dataRow);
                    });
                }
            });
        });
    }

    /*Edit Return */
    const goToEditReturn = (sID: string) => {
        navigate(`/EquipmentReturnForm?sMode=${sMode}&sID=${encodeURI(sID)}`);
    };

    /*DeleteTable Return */
    const onDeleteReturn = (e) => {
        DialogFn.Submit("คุณต้องการลบข้อมูลใช่หรือไม่ ?", () => {
            AxiosFn.Post(`Equipment/RemoveDataTableReturn`, { lstID: e }, (result) => {
                if (result.nStatusCode === 200) {
                    DialogFn.Success("ลบสำเร็จ", () => {
                        getTableEquipment(dataRow);
                    });
                }
            });
        });
    }

    /*Table Return */
    const dataColumnReturn: any = [
        {
            renderHeader: (item) => (
                <>
                    <BtnAddOnTable
                        IsDisabled={!isPermission}
                        onClick={() => navigate("/EquipmentReturnForm?sMode=" + sMode)}
                        id={"Add"} />
                </>
            ),
            field: "ปุ่ม (เพิ่ม/แก้ไข)",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 60,
            getActions: (item) => {
                if (!isPermission) {
                    return [
                        <BtnViewOnTable
                            id="btnView"
                            key={item.row.sID}
                            onClick={() => goToEditReturn(item.row.sID)}
                        />
                    ];
                } else {
                    return [
                        <BtnEditOnTable
                            key={item.row.sID}
                            id="btnEdit"
                            onClick={() => goToEditReturn(item.row.sID)}
                        />
                    ];
                }
            },
        },
        {
            field: "sReturnDate",
            headerName: `${I18n.SetText("Material.sReturnDate")}`,
            headerAlign: "center",
            align: "Left",
            sortable: true,
            width: 120,
        },
        {
            field: "sDocumentNo",
            headerName: `${I18n.SetText("Equipment.sDocumentNoRetrun")}`,
            headerAlign: "center",
            align: "Left",
            sortable: true,
            width: 150,

        },
        {
            field: "sNameReturn",
            headerName: `${I18n.SetText("Equipment.sNameReturn")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 250,
        },
        {
            field: "sReceiverUnitType",
            headerName: `${I18n.SetText("Equipment.UnitReturn")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 250,
        },
        {
            field: "sEquipmentTotal",
            headerName: `${I18n.SetText("Equipment.sEquipmentTotal")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 150,
        },

        {
            field: "sUpdate",
            headerName: "วันที่แก้ไขล่าสุด",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 200,
            renderCell: (item) => {
                return (
                    <>
                        <Grid sx={{ mr: "4px" }}>
                            {item.row.sUpdate}
                        </Grid>
                        <IconButton size="small"
                            onClick={(e) => { handleClick(e); handleViewInfo(item.row); }}
                        >
                            <InfoIcon
                                style={{ color: "#6e130d", cursor: "pointer" }}
                            />
                        </IconButton>
                    </>
                )
            }
        },
    ];


    /*Table Cutoff */
    const dataColumnCutoff: any = [
        {
            renderHeader: (item) => (
                <>
                    <BtnAddOnTable
                        IsDisabled={!isPermission}
                        onClick={() => navigate("/EquipmentCusoffForm?sMode=" + sMode)}
                        id={"Add"} />
                </>
            ),
            field: "ปุ่ม (เพิ่ม/แก้ไข)",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 60,
            getActions: (item) => {
                if (!isPermission) {
                    return [
                        <BtnViewOnTable
                            id="btnView"
                            key={item.row.sID}
                            onClick={() => goToEditCusOff(item.row.sID)}
                        />
                    ];
                } else {
                    return [
                        <BtnEditOnTable
                            key={item.row.sID}
                            id="btnEdit"
                            onClick={() => goToEditCusOff(item.row.sID)}
                        />
                    ];
                }
            },
        },
        {
            field: "nYear",
            headerName: `${I18n.SetText("Equipment.sYear")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 100,
        },
        {
            field: "sCutoffDate",
            headerName: `${I18n.SetText("Equipment.sDateCutoff")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 130,

        },
        {
            field: "nCusOffNo",
            headerName: `${I18n.SetText("Equipment.sCutoffNo")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 130,
        },
        {
            field: "sNameCreate",
            headerName: `${I18n.SetText("Equipment.sNameCusoff")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 240,
        },
        {
            field: "sTotalItemCusOff",
            headerName: `${I18n.SetText("Equipment.sTotalCusoff")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 170,
        },
        {
            field: "sFileCusoff",
            headerName: `${I18n.SetText("Equipment.sFileCusoff")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 100,
            renderCell: (item) => (
                <Tooltip title={`${I18n.SetText("PublishDoc.sDetail")}`}>
                    <IconButton size="small" onClick={() => handleViewFile(item.row)}>
                        <InsertDriveFileIcon
                            style={{ color: "#6e130d", cursor: "pointer" }}
                        />
                    </IconButton>
                </Tooltip>
            ),
        },
        {
            field: "sUpdate",
            headerName: `${I18n.SetText("Equipment.sDateUpdate")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 200,
            renderCell: (item) => {
                return (
                    <>
                        <Grid sx={{ mr: "4px" }}>
                            {item.row.sUpdate}
                        </Grid>
                        <IconButton size="small"
                            onClick={(e) => { handleClick(e); handleViewInfo(item.row); }}
                        >
                            <InfoIcon
                                style={{ color: "#6e130d", cursor: "pointer" }}
                            />
                        </IconButton>
                    </>
                )
            }
        },
    ];

    const handleViewFile = (objRow) => {
        let objParam = { sID: objRow.sID };
        AxiosFn.Post(`Equipment/OnViewFile`, objParam, (result) => {
            DialogFn.UnBlockUI();
            setArrModalFile(result.lstViewFile);
            setIsOpenFile(true);
        });
    };

    {/*Edit CusOff */ }
    const goToEditCusOff = (sID: string) => {
        navigate(`/EquipmentCusoffForm?sMode=${sMode}&sID=${encodeURI(sID)}`);
    };

    /*DeleteTable CusOff */
    const onDeleteCusOff = (e) => {
        DialogFn.Submit("คุณต้องการลบข้อมูลใช่หรือไม่ ?", () => {
            AxiosFn.Post(`Equipment/RemoveDataTableCusOff`, { lstID: e }, (result) => {
                if (result.nStatusCode === 200) {
                    DialogFn.Success("ลบสำเร็จ", () => {
                        getTableEquipment(dataRow);
                    });
                }
            });
        });
    }

    const getFormInitial = () => {
        AxiosFn.Get(`Equipment/GetFormInitial`, {}, (result) => {
            setarrGovernmentUnit(result.lstGovernmentUnit);
            setarrMethodType(result.lstMethodType);


        })
    }

    useEffect(() => {
        getFormInitial();
        getTableEquipment(dataRow);
    }, []);


    return (
        <React.Fragment>
            <Grid item xs={12} md={12} container spacing={2} justifyItems={'flex-start'} justifyContent={'end'}>
                <FormProvider {...form}>
                    <Grid item xs={12} md={6}>
                        <TextBoxItem
                            required={false}
                            label={sMode == "Withdraw" ? `${I18n.SetText("Equipment.sDocOrderAndName")}` : sMode == "Receive" ? `${I18n.SetText("Equipment.sOrder")}` : sMode == "Cutoff" ? "หมายเลขครุภัณฑ์/รายการ" : "เลขที่เอกสาร,ชื่อผู้ขอคืน"}
                            id={'sOrderNo'}
                            name={'sOrderNo'}
                            maxLength={250}
                            type={'text'}
                            IsShowMessageError
                            disabled={!isPermission}
                        />
                    </Grid>
                    {sMode == "Cutoff" ? (
                        <Grid item xs={12} md={3}>
                            <DatePickerItem
                                name={`dYear`}
                                id={`dYear`}
                                label={`ปี`}
                                IsYearPicker
                                required={false}
                                disabled={false}
                                fullWidth
                            />
                        </Grid>
                    ) : (
                        <>
                            <Grid item xs={12} md={3}>
                                <DatePickerItem
                                    name={"dStartDate"}
                                    id={"dStartDate"}
                                    label={`${I18n.SetText("Leave.sStartDate")}`}
                                    fullWidth={true}
                                    required={false}
                                    disabled={false}
                                    maxDate={form.watch("dEndDate")}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <DatePickerItem
                                    name={"dEndDate"}
                                    id={"dEndDate"}
                                    label={`${I18n.SetText("Leave.sEndDate")}`}
                                    fullWidth={true}
                                    required={false}
                                    disabled={false}
                                    minDate={form.watch("dStartDate")}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <MultipleSelectItem
                                    id={'nGovernmentUnit'}
                                    name={'nGovernmentUnit'}
                                    label={`${I18n.SetText("Equipment.nGovernmentUnit")}`}
                                    placeholder={`${I18n.SetText("Equipment.nGovernmentUnit")}`}
                                    options={sMode === "Receive" ? arrGovernmentUnit : arrMaterialType}
                                    required={false}
                                    disabled={!isPermission}
                                    limitTag={1}
                                />
                            </Grid>
                        </>
                    )}
                    {sMode === "Receive" &&
                        <Grid item xs={12} md={4}>
                            <MultipleSelectItem
                                id={'nMethodType'}
                                name={'nMethodType'}
                                label={`${I18n.SetText("Equipment.sMethodType")}`}
                                placeholder={`${I18n.SetText("Equipment.sMethodType")}`}
                                options={arrMethodType || []}
                                required={false}
                                disabled={!isPermission}
                                limitTag={1}
                            />
                        </Grid>
                    }
                    <Grid item xs={12} md={1} container spacing={1} justifyItems={'flex-start'} justifyContent={'end'}>
                        <Grid item>
                            <BtnClear id={'btnClearSearchAll'} IsCircleWithOutText={true} onClick={() => { onClear(); }} />
                        </Grid>
                        <Grid item>
                            <BtnSearch id={'btnSearchAll'} IsCircleWithOutText={true} onClick={() => { getTableEquipment(dataRow); }} />
                        </Grid>
                    </Grid>
                </FormProvider>
            </Grid>
            <Grid item xs={12} sx={{ mt: 1 }}>
                <DataGrid
                    sTableID='tb1'
                    columns={sMode == "Receive" ? dataColumn : sMode == "Return" ? dataColumnReturn : sMode === "Cutoff" ? dataColumnCutoff : dataColumnWithdraw}
                    rows={dataRow}
                    isHiddenToolHead={true}
                    onLoadData={getTableEquipment}
                    isLoading={loadingTable}
                    isShowCheckBox={isPermission}
                    onRowSelectable={(p) => !p.row.isDelete}
                    onDelete={sMode == "Receive" ? onDeleteReceive : sMode == "Return" ? onDeleteReturn : sMode === "Cutoff" ? onDeleteCusOff : onDeleteWithdraw}
                />
            </Grid>

            {/*PopUp Receive File */}
            <DialogPreview
                IsOpen={isOpenFile}
                Title={`${I18n.SetText("PublishDoc.sFile")}`}
                required={true}
                onClose={() => setIsOpenFile(false)}
                sMaxWidth="sm"
                CloseSave={true}
            >
                {arrModalFile.map(m => {
                    let sFileType = m.sFileName.split(".")[m.sFileName.split(".").length - 1].toLowerCase();
                    let sUrl = m.sFileLink;
                    return (
                        <Grid container key={m.sFileName} justifyContent={"space-between"} xs={12} md={12} spacing={1}>
                            <Grid item sx={{ marginTop: 2 }}>
                                <div onClick={() => handleOpenFile(m.sFileLink)} style={{ cursor: "pointer", color: "blue", marginTop: 1 }}>
                                    <Circle
                                        sx={{
                                            color: "blue",
                                            height: "7px",
                                            marginLeft: 1,
                                        }}
                                    />
                                    {m.sFileName}
                                </div>
                            </Grid >
                            <Grid item sx={{ marginTop: 1 }}>
                                {sFileType === "jpg" || sFileType === "jpeg" || sFileType === "png" && (
                                    <Grid item md={12} xs={12}>
                                        <Tooltip title={`${I18n.SetText("PublishDoc.sShowFile")}`}>
                                            <Avatar
                                                alt=""
                                                src={sUrl}
                                                sx={{ width: 40, height: 40, cursor: "pointer" }}
                                                onClick={() => handleOpenFile(m.sFileLink)}
                                            />
                                        </Tooltip>
                                    </Grid>
                                )}
                                {sFileType === "pdf" && (
                                    <Grid item md={12} xs={12}>
                                        <Tooltip title={`${I18n.SetText("PublishDoc.sShowFile")}`}>
                                            <img
                                                style={{ width: 30, height: 30, cursor: "pointer", marginBottom: 1 }}
                                                src={PDFIcon}
                                                alt=""
                                                onClick={() => handleOpenFile(m.sFileLink)}
                                            />
                                        </Tooltip>
                                    </Grid>
                                )}
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                        </Grid>
                    );
                })
                }

            </DialogPreview>

            {/* pop over UserUpdate */}
            <Popover
                id={`sUpdateName`}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Typography sx={{ p: 2 }}>{sUpdateName}</Typography>
            </Popover>
        </React.Fragment >
    )
}
export default EquipmentListTabel;

